import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { ItemTaskSchedulerInstruction } from '@common/task-scheduler/frontend-shared';
import * as i0 from "@angular/core";
let PflegethekeAppFrontendAdminFeature = /*#__PURE__*/(() => {
  let PflegethekeAppFrontendAdminFeature = class PflegethekeAppFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@pflegetheke/app/frontend-admin","featureId":"pflegetheke-app"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineModelInstructions([{
        modelId: 'UserItem',
        targetSlotId: 'sidebar',
        displayContext: ['admin', 'crud'],
        displayInEditModes: ['edit'],
        instructions: [new ItemTaskSchedulerInstruction({})]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPflegethekeAppFrontendAdminFeature_BaseFactory;
        return function PflegethekeAppFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵPflegethekeAppFrontendAdminFeature_BaseFactory || (ɵPflegethekeAppFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PflegethekeAppFrontendAdminFeature)))(__ngFactoryType__ || PflegethekeAppFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PflegethekeAppFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  };
  PflegethekeAppFrontendAdminFeature = __decorate([ClassName("PflegethekeAppFrontendAdminFeature")], PflegethekeAppFrontendAdminFeature);
  return PflegethekeAppFrontendAdminFeature;
})();
export { PflegethekeAppFrontendAdminFeature };